<template>
  <main class="-mt-32" v-if="loaded">
    <div class="px-4 py-10 pb-12 mx-auto -mt-32 max-w-7xl sm:px-6 lg:px-8">
      <div class="overflow-hidden bg-white shadow sm:rounded-md">
        <div class="bg-white">
          <div
            class="flex flex-wrap items-center justify-between px-4 pt-5 border-b sm:px-6 sm:flex-no-wrap"
          >
            <div class="block">
              <div class="border-gray-200">
                <nav class="flex -mb-px">
                  <a
                    href="#info"
                    @click="tab = 'info'"
                    :class="{
                      'border-indigo-500 text-indigo-500 focus:text-indigo-800 focus:border-indigo-700':
                        tab == 'info',
                      'border-transparent text-gray-500 focus:text-gray-700 focus:border-gray-300':
                        tab != 'info',
                    }"
                    class="inline-flex items-center px-1 py-4 text-sm font-medium leading-5 text-gray-500 border-b-2 group hover:text-gray-700 hover:border-gray-300 focus:outline-none"
                  >
                    <svg
                      :class="{
                        'text-indigo-500 group-focus:text-indigo-600':
                          tab == 'info',
                        'text-gray-400 group-hover:text-gray-500 group-focus:text-gray-600':
                          tab != 'info',
                      }"
                      class="-ml-0.5 mr-2 h-5 w-5"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-6-3a2 2 0 11-4 0 2 2 0 014 0zm-2 4a5 5 0 00-4.546 2.916A5.986 5.986 0 0010 16a5.986 5.986 0 004.546-2.084A5 5 0 0010 11z"
                        clip-rule="evenodd"
                      />
                    </svg>
                    <span>Visita</span>
                  </a>

                  <template v-if="examination.id">
                    <a
                      href="#files"
                      @click="tab = 'files'"
                      :class="{
                        'border-indigo-500 text-indigo-500 focus:text-indigo-800 focus:border-indigo-700':
                          tab == 'files',
                        'border-transparent text-gray-500 focus:text-gray-700 focus:border-gray-300':
                          tab != 'files',
                      }"
                      class="inline-flex items-center px-1 py-4 ml-8 text-sm font-medium leading-5 border-b-2 group hover:text-gray-700 hover:border-gray-300 focus:outline-none"
                    >
                      <svg
                        :class="{
                          'text-indigo-500 group-focus:text-indigo-600':
                            tab == 'files',
                          'text-gray-400 group-hover:text-gray-500 group-focus:text-gray-600':
                            tab != 'files',
                        }"
                        class="-ml-0.5 mr-2 h-5 w-5"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                      >
                        <path
                          d="M9 2a2 2 0 00-2 2v8a2 2 0 002 2h6a2 2 0 002-2V6.414A2 2 0 0016.414 5L14 2.586A2 2 0 0012.586 2H9z"
                        ></path>
                        <path
                          d="M3 8a2 2 0 012-2v10h8a2 2 0 01-2 2H5a2 2 0 01-2-2V8z"
                        ></path>
                      </svg>
                      <span>Allegati</span>
                    </a>
                    <a
                      href="#photos"
                      @click="tab = 'photos'"
                      :class="{
                        'border-indigo-500 text-indigo-500 focus:text-indigo-800 focus:border-indigo-700':
                          tab == 'photos',
                        'border-transparent text-gray-500 focus:text-gray-700 focus:border-gray-300':
                          tab != 'photos',
                      }"
                      class="inline-flex items-center px-1 py-4 ml-8 text-sm font-medium leading-5 border-b-2 group focus:outline-none"
                    >
                      <svg
                        :class="{
                          'text-indigo-500 group-focus:text-indigo-600':
                            tab == 'photos',
                          'text-gray-400 group-hover:text-gray-500 group-focus:text-gray-600':
                            tab != 'photos',
                        }"
                        class="-ml-0.5 mr-2 h-5 w-5"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                      >
                        <path
                          d="M5 8a1 1 0 011-1h1V6a1 1 0 012 0v1h1a1 1 0 110 2H9v1a1 1 0 11-2 0V9H6a1 1 0 01-1-1z"
                        ></path>
                        <path
                          fill-rule="evenodd"
                          d="M2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8zm6-4a4 4 0 100 8 4 4 0 000-8z"
                          clip-rule="evenodd"
                        ></path>
                      </svg>
                      <span>Foto</span>
                    </a>
                  </template>
                </nav>
              </div>
            </div>
            <template v-if="examination.id" class="flex-shrink-0 ml-4">
              <div class="mt-4 flex md:mt-0 md:ml-4">
                <span class="shadow-sm rounded-md">
                  <button
                    @click="destroy"
                    type="button"
                    class="inline-flex items-center px-4 py-2 border border-transparent text-sm leading-5 font-medium rounded-md text-white bg-red-600 hover:bg-red-500 focus:outline-none focus:shadow-outline-red focus:border-red-700 active:bg-red-700 transition duration-150 ease-in-out"
                  >
                    Elimina
                  </button>
                </span>
              </div>
            </template>
          </div>
        </div>

        <component
          :is="component"
          :patient_id="patient_id"
          :id="id"
        ></component>
      </div>
    </div>
  </main>
</template>

<script>
import { mapState } from "vuex";
import { Italian } from "flatpickr/dist/l10n/it";
import CodiceFiscale from "calcolo-codice-fiscale";

import ExaminationInfo from "./ExaminationInfo";
import ExaminationFiles from "./ExaminationFiles";
import ExaminationPhotos from "./ExaminationPhotos";

export default {
  props: {
    patient_id: {
      required: true,
    },
    id: {
      required: false,
    },
  },

  data: () => {
    return {
      loaded: false,
      tab: "",
    };
  },

  components: {
    ExaminationInfo,
    ExaminationFiles,
    ExaminationPhotos,
  },

  computed: {
    ...mapState("patient", ["patient"]),
    ...mapState("examination", ["examination"]),
    component() {
      return "examination-" + this.tab;
    },
  },

  methods: {
    save() {
      this.$store.dispatch("examination/SAVE", this.examination);
    },
    destroy() {
      if (confirm("Sicuro di voler cancellare la visita?")) {
        this.$store.dispatch("examination/DELETE");
        this.$router.go(-1);
      }
    },
  },

  async mounted() {
    this.$store.dispatch("patient/PATIENT", { id: this.patient_id });
    this.$store.dispatch("examination/RESET");
    this.tab =
      this.$router.currentRoute.hash.length > 1
        ? this.$router.currentRoute.hash.replace("#", "")
        : "info";
    if (this.id) {
      await this.$store.dispatch("examination/EXAMINATION", {
        id: this.id,
      });
    }

    this.examination.patient_id = this.patient_id;
    this.loaded = true;
  },
};
</script>
